import React, { useEffect } from "react";
import './App.css';
import Home from "./components/pages/Home";
import ContactUs from "./components/pages/Contact";
import About from "./components/pages/AboutUs";
import NavBar from "./components/inc/NavBar";
import Footer from "./components/inc/Footer";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";

function ScrollManager() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const timer = window.setTimeout(() => {
        const section = document.getElementById(id);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 80);
      return () => window.clearTimeout(timer);
    }

    window.scrollTo({ top: 0, behavior: 'auto' });
    return undefined;
  }, [location.pathname, location.hash]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="app-shell">
        <ScrollManager />
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
